import { render, staticRenderFns } from "./CallVerificationLogin.vue?vue&type=template&id=fb74216e&lang=html"
import script from "./CallVerificationLogin.vue?vue&type=script&lang=js"
export * from "./CallVerificationLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports